<span> {{ getValue() | amountFormat }}</span>
